export default function SandboxDashboardItems() {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">Dashboard Items</h1>
      <div className="space-y-4">
        {[1, 2, 3, 4, 5].map((item) => (
          <div key={item} className="p-4 bg-card border border-border rounded-lg">
            <h3 className="font-semibold">Item {item}</h3>
            <p className="text-sm text-muted-foreground">
              This is a sample item in the dashboard
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
